export default __webpack_public_path__ + "media/heart-fill-o.40eac3ed.svg";